import { SortFn, SortResult } from "./interfaces";

export const OrderSorter: SortFn = (a, b) => {
  if (a.order < b.order) {
    return SortResult.INCORRECT_ORDER;
  } else if (a.order === b.order) {
    return SortResult.EQUAL;
  } else {
    return SortResult.CORRECT_ORDER;
  }
};
